class ImageSlider {
  constructor(el) {
    this.el = el;
    this.viewport = el.querySelector('.image-slider__viewport');
    this.track = el.querySelector('.image-slider__track');
    this.slides = Array.from(el.querySelectorAll('.image-slider__slide'));
    this.dots = Array.from(el.querySelectorAll('.image-slider__dot'));
    this.prevBtn = el.querySelector('.image-slider__arrow--prev');
    this.nextBtn = el.querySelector('.image-slider__arrow--next');

    this.current = 0;
    this.autoplay = el.dataset.autoplay === 'true';
    this.interval = parseInt(el.dataset.interval, 10) || 5000;
    this.timer = null;

    if (this.slides.length === 0) return;

    // 初期表示
    this.update(false);
    if (this.slides.length <= 1) return;

    this.bindEvents();
    if (this.autoplay) this.start();
  }

  // 中央スライドがビューポート中央に来るように track を移動
  update(animate = true) {
    const activeSlide = this.slides[this.current];
    if (!activeSlide) return;

    if (!animate) {
      this.track.style.transition = 'none';
    }

    const viewportWidth = this.viewport.offsetWidth;
    const slideWidth = activeSlide.offsetWidth;
    const slideLeft = activeSlide.offsetLeft;

    // 中央スライドの中心をビューポートの中心に合わせる
    const offset = (viewportWidth / 2) - (slideLeft + slideWidth / 2);
    this.track.style.transform = `translateX(${offset}px)`;

    // アクティブクラスの付け替え
    this.slides.forEach((s, i) => s.classList.toggle('is-active', i === this.current));
    this.dots.forEach((d, i) => d.classList.toggle('is-active', i === this.current));

    if (!animate) {
      // 強制リフローで transition:none を確定させてから元に戻す
      void this.track.offsetWidth;
      this.track.style.transition = '';
    }
  }

  goTo(index) {
    this.current = (index + this.slides.length) % this.slides.length;
    this.update(true);
  }

  next() { this.goTo(this.current + 1); }
  prev() { this.goTo(this.current - 1); }

  start() {
    this.stop();
    this.timer = setInterval(() => this.next(), this.interval);
  }

  stop() {
    if (this.timer) { clearInterval(this.timer); this.timer = null; }
  }

  restart() { if (this.autoplay) this.start(); }

  bindEvents() {
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => { this.next(); this.restart(); });
    if (this.prevBtn) this.prevBtn.addEventListener('click', () => { this.prev(); this.restart(); });

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.goTo(parseInt(dot.dataset.dotIndex, 10));
        this.restart();
      });
    });

    // 前後スライドをクリックしたらそのスライドへ移動
    this.slides.forEach((slide, i) => {
      slide.addEventListener('click', (e) => {
        if (i !== this.current) {
          e.preventDefault(); // リンク遷移せずまず中央へ
          this.goTo(i);
          this.restart();
        }
      });
    });

    // ホバー中は自動再生を停止
    this.el.addEventListener('mouseenter', () => this.stop());
    this.el.addEventListener('mouseleave', () => this.restart());

    // スワイプ対応
    let touchStartX = 0;
    this.track.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
      this.stop();
    }, { passive: true });

    this.track.addEventListener('touchend', (e) => {
      const diff = touchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 40) {
        diff > 0 ? this.next() : this.prev();
      }
      this.restart();
    }, { passive: true });

    // リサイズ時に位置を再計算(アニメなし)
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => this.update(false), 150);
    });

    // 画像読み込み後にも再計算(高さ確定による位置ズレ防止)
    this.el.querySelectorAll('img').forEach((img) => {
      if (!img.complete) {
        img.addEventListener('load', () => this.update(false), { once: true });
      }
    });
  }
}

function initImageSliders() {
  document.querySelectorAll('.image-slider').forEach((el) => {
    if (!el.dataset.initialized) {
      el.dataset.initialized = 'true';
      new ImageSlider(el);
    }
  });
}

document.addEventListener('DOMContentLoaded', initImageSliders);

document.addEventListener('shopify:section:load', (e) => {
  const el = e.target.querySelector('.image-slider');
  if (el) { el.dataset.initialized = ''; initImageSliders(); }
});
